module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "activity-item"
  }, [_c('i', {
    class: _vm.bgclass
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "activity-name"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('span', {
    staticClass: "activity-date"
  }, [_vm._v(_vm._s(_vm.date))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a68e392","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/ActiveItem.vue
// module id = 741
// module chunks = 0